import assert from 'minimalistic-assert'

import { forever } from '../constants.js'

const unitToMS = {
  second: 1000,
  month: 30 * 24 * 60 * 60 * 1000,
}

export const toMS = ({ unit, count }) => {
  assert(!!unitToMS[unit], 'invalid unit')
  return count === forever.count ? Infinity : unitToMS[unit] * count
}
